import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';

// Vitrinin giriş animasyonları başlangıçta opacity:0 ile durur — ama YALNIZ
// html.js altında (bkz. styles/marketing.css). Bu sınıfı sadece tarayıcı ekler:
// sunucunun ürettiği HTML ve JS'i kapalı bir istemci içeriği GÖRÜNÜR bulur.
// Aksi hâlde bir crawler JS çalıştırmadan baktığında bomboş bir sayfa görürdü.
document.documentElement.classList.add('js');

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
